import api from '../api'

const fetchDiagnostics = (params = {}) => {
  const agents = Object.keys(params).find((item) => item === 'diagnosticClassifications.diagnosticClassificationAgents.agent[]')
  let agentsParams = ''
  if (agents) {
    const valuesAgents = params?.[`${agents}`]
    agentsParams += '?'
    valuesAgents.forEach((item) => {
      agentsParams += `${agents}=${item}&`
    })
    delete params?.[`${agents}`]
  }
  return api.get('/diagnostics' + agentsParams, { params: { farm: atob(window.localStorage.getItem('farm-id')), ...params } })
}

const fetchDiagnosticsV2 = (params = {}) => {
  const agents = Object.keys(params).find((item) => item === 'diagnosticClassifications.diagnosticClassificationAgents.agent[]')
  let agentsParams = ''
  if (agents) {
    const valuesAgents = params?.[`${agents}`]
    agentsParams += '?'
    valuesAgents.forEach((item) => {
      agentsParams += `${agents}=${item}&`
    })
    delete params?.[`${agents}`]
  }
  return api.get('/v2/diagnostics/results' + agentsParams, { params: { farm: atob(window.localStorage.getItem('farm-id')), ...params } })
}

const fetchDiagnosticsById = (id, params = {}) => {
  return api.get(`/v2/diagnostics/result/${id}`, { params: { ...params } })
}

const createDiagnostic = (body = {}) => {
  return api.post('/diagnostics', {
    ...body,
    farm: atob(window.localStorage.getItem('farm-id'))
  })
}

const updateDiagnostic = (id, body = {}) => {
  return api.put(`/diagnostics/${id}`, body)
}

const reprocessDiagnostic = (id, body = {}) => {
  return api.put(`/diagnostics/${id}/reprocess`, body)
}

const updateDiagnosticsTreatments = (id, body = {}) => {
  return api.put(`/diagnostics/${id}/treatment_economy`, body)
}

const uploadPlateImage = (id, body = {}) => {
  return api.post(`/diagnostics/${id}/upload_plate_image`, body, {
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

const downloadPlateImage = (url) => {
  return api.get(url, { responseType: 'blob' })
}

const getPlateImage = (id) => {
  return (`${process.env.REACT_APP_API_URL}/diagnostics/${id}/download_plate_image`)
}

const deleteDiagnostic = (id) => {
  return api.put(`/diagnostics/${id}`, { deleted: true })
}

export {
  fetchDiagnostics,
  fetchDiagnosticsV2,
  fetchDiagnosticsById,
  createDiagnostic,
  updateDiagnostic,
  deleteDiagnostic,
  uploadPlateImage,
  getPlateImage,
  downloadPlateImage,
  updateDiagnosticsTreatments,
  reprocessDiagnostic
}
